import { CloudQueue, DeviceHub, HistoryToggleOff } from '@mui/icons-material';
import { Grid, Tooltip } from '@mui/material';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';

const SystemModuleList = () => {
  const { data: modules } = useSystemModules({});
  const moduleIcons = [];
  if (modules?.ADVANCED_HISTORY)
    moduleIcons.push(
      <Tooltip key={0} title='Advanced History' placement='bottom-start'>
        <HistoryToggleOff
          sx={{ marginRight: '.5rem' }}
          fontSize='large'
        ></HistoryToggleOff>
      </Tooltip>
    );
  if (modules?.WEATHER)
    moduleIcons.push(
      <Tooltip key={1} title='Weather' placement='bottom-start'>
        <CloudQueue sx={{ marginRight: '.5rem' }} fontSize='large'></CloudQueue>
      </Tooltip>
    );
  if (modules?.SWITCHES)
    moduleIcons.push(
      <Tooltip key={2} title='Switches' placement='bottom-start'>
        <DeviceHub sx={{ marginRight: '.5rem' }} fontSize='large'></DeviceHub>
      </Tooltip>
    );
  return <Grid container>{moduleIcons.map((icon, index) => icon)}</Grid>;
};

export default SystemModuleList;
